import React from "react";
import { Input, Flex, message, Select, Typography } from "antd";
import { ContactOption } from "../../index";
import { useTranslation } from "react-i18next";
import { ContactsOutlined, ShopOutlined } from "@ant-design/icons";
import { NIVEL } from "@/utilities/niveles-de-permiso";

const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const selectOptions = [
  { value: "admin", label: NIVEL.admin },
  { value: "editor", label: NIVEL.editor },
  { value: "viewer", label: NIVEL.viewer },
];

type PermissionsSelectValues = {
  order: string | null;
  payment: string | null;
  shipment: string | null;
};

type PermissionsCardProps = {
  store?: { name?: string };
  selectedContact?: ContactOption;
  permissionsSelects: PermissionsSelectValues;
  setPermissionsSelects: any;
  isCustomer: boolean;
};

export const PermissionsCard: React.FC<PermissionsCardProps> = ({
  store,
  selectedContact,
  permissionsSelects,
  setPermissionsSelects,
  isCustomer,
}) => {
  const { t } = useTranslation();

  return (
    <Flex vertical gap={140}>
    <Flex vertical className="card-permissions">
      <Text strong style={{ textTransform: "capitalize" }}>
        {selectedContact?.role === "store" ? (
          <ShopOutlined />
        ) : (
          <ContactsOutlined />
        )}
        <span style={{ marginLeft: 8 }}>
          {selectedContact?.type === "" ? "Customer" : `${selectedContact?.role} ${selectedContact?.type}`}
        </span>
      </Text>
      <Flex style={{ padding: 16 }} vertical gap={16}>
        <Flex gap={8} align="center" justify="space-between">
          <Text strong>{selectedContact?.name}</Text>

          {!isCustomer && (
            <Select
              size="small"
              placeholder="Select"
              style={{ minWidth: "35%" }}
              value={permissionsSelects}
              status={!permissionsSelects ? "error" : ""}
              onChange={(value) => setPermissionsSelects(value)}
            >
              {selectOptions.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          )}
        </Flex>
      </Flex>
    </Flex>

      <Flex vertical>
        <Text type="secondary">{t("label.message")}</Text>
        <Input.TextArea disabled rows={3} />
      </Flex>
    </Flex>
  );
};
